import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-644d0586"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-d-flex p-flex-wrap p-jc-around p-ai-center p-px-3 p-py-6 footer" }
const _hoisted_2 = {
  class: "p-mb-4",
  style: {"max-width":"325px"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/locaa.png",
  width: "300",
  alt: "locaa,pos"
}, null, -1))
const _hoisted_4 = { class: "p-d-flex p-flex-column" }
const _hoisted_5 = { href: "#feature" }
const _hoisted_6 = {
  href: "#subscription",
  class: "p-my-2"
}
const _hoisted_7 = { class: "p-d-flex p-flex-column" }
const _hoisted_8 = {
  id: "contact",
  class: "p-col-12 p-d-flex p-flex-wrap p-jc-around p-ai-center"
}
const _hoisted_9 = { class: "p-ml-3" }
const _hoisted_10 = { style: {"color":"#f9a826"} }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-comment" }, null, -1))
const _hoisted_12 = { class: "p-grid" }
const _hoisted_13 = { class: "p-col-12 p-md-6 p-pl-0 p-d-flex p-flex-column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Fieldset = _resolveComponent("Fieldset")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("a", _hoisted_5, _toDisplayString(_ctx.$t("home.ourFeature")), 1),
      _createElementVNode("a", _hoisted_6, _toDisplayString(_ctx.$t("home.ourPrice")), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_router_link, { to: "/account/sign-in" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("login")), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/account/sign-up",
        class: "p-my-2"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("signUp.signUp")), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: "/privacy" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("workspaceLayout.privacy")), 1)
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_Divider, { class: "p-col-12" }),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", null, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("home.contactUs")), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contacts, (pop, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "p-d-flex p-ai-center p-my-4"
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(pop.icon)
            }, null, 2),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$tm("home.contacts")[index]), 1),
              _createElementVNode("small", _hoisted_10, _toDisplayString(pop.value), 1)
            ])
          ]))
        }), 128))
      ]),
      _createVNode(_component_Fieldset, {
        style: {"background":"gainsboro"},
        class: "p-col-12 p-md-6"
      }, {
        legend: _withCtx(() => [
          _hoisted_11,
          _createTextVNode(" " + _toDisplayString(_ctx.$t("home.drop")), 1)
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_InputText, {
                modelValue: _ctx.form.subject.$value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.subject.$value) = $event)),
                placeholder: _ctx.$t('home.subject') + '*',
                onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.subject.$validate())),
                class: _normalizeClass({ 'p-invalid': _ctx.form.subject.$hasError })
              }, null, 8, ["modelValue", "placeholder", "class"]),
              _createVNode(_component_InputText, {
                modelValue: _ctx.form.from.$value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.from.$value) = $event)),
                placeholder: _ctx.$t('home.name') + '*',
                onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.from.$validate())),
                class: _normalizeClass([{ 'p-invalid': _ctx.form.from.$hasError }, "p-mt-3"])
              }, null, 8, ["modelValue", "placeholder", "class"]),
              _createVNode(_component_InputText, {
                modelValue: _ctx.form.to.$value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.to.$value) = $event)),
                onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.to.$validate())),
                class: _normalizeClass(["p-my-3", { 'p-invalid': _ctx.form.to.$hasError }]),
                placeholder: _ctx.$t('home.email') + '*'
              }, null, 8, ["modelValue", "placeholder", "class"])
            ]),
            _createVNode(_component_Textarea, {
              modelValue: _ctx.form.text.$value,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.text.$value) = $event)),
              placeholder: _ctx.$t('home.message') + '*',
              class: _normalizeClass(["p-col-12 p-md-6", { 'p-invalid': _ctx.form.text.$hasError }]),
              onBlur: _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.text.$validate()))
            }, null, 8, ["modelValue", "placeholder", "class"]),
            _createVNode(_component_Button, {
              "icon-pos": "right",
              label: _ctx.$t('submit'),
              icon: "pi pi-send",
              class: _normalizeClass(["p-col-12 p-mt-2 p-button-outlined", { 'p-button-danger': _ctx.hasError }]),
              disabled: _ctx.hasError || _ctx.loading,
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.sendMail())),
              loading: _ctx.loading
            }, null, 8, ["label", "disabled", "class", "loading"])
          ])
        ]),
        _: 1
      })
    ])
  ]))
}